import React from 'react'
import { withTranslation } from 'react-i18next'
import * as UIcons from '@iconscout/react-unicons'

export default withTranslation()(function StepSidebar({ t, steps, currentStep, furthestStep, onNavigate }) {
  return (
    <nav className="w-[350px] shrink-0 border-r border-border-lines px-8 py-8 overflow-y-auto">
      <ul className="flex flex-col gap-5">
        {
          steps.map((step, index) => {
            const isCompleted = index < furthestStep
            const isCurrent = index === currentStep
            const isReachable = index <= furthestStep

            return (
              <li key={step.key}>
                <button
                  type="button"
                  disabled={!isReachable}
                  onClick={() => onNavigate(index)}
                  className={`flex items-center gap-3 text-left ${isReachable ? '' : 'cursor-not-allowed opacity-60'}`}
                >
                  <span className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-semibold shrink-0 ${
                    isCompleted ? 'bg-success text-white' : isCurrent ? 'bg-primary text-white' : 'bg-background text-secondary'
                  }`}
                  >
                    {isCompleted ? <UIcons.UilCheck size={14} /> : index + 1}
                  </span>

                  <span className={`text-sm ${isCurrent ? 'font-semibold text-dark-blue' : isCompleted ? 'text-dark-blue' : 'text-secondary'}`}>
                    {t(step.labelKey)}
                  </span>
                </button>
              </li>
            )
          })
        }
      </ul>
    </nav>
  )
})
